import * as React from "react";
import { useState, useContext, createContext, useEffect } from "react";
import { makeStyles, Theme, createStyles } from "@mui/styles";
import {ValueContext} from '~common/components/form-def-field-fc';
import {red, grey} from '@mui/material/colors';
import {CircularProgress} from '@mui/material';
import Dropzone from '~common/components/versioned-document-dropzone';
import * as request from 'superagent';
import PortalUserContext from '~common/lib/portal-user-context';
import {cloneDeep} from 'lodash'
import VersionedDocumentListItem from "~common/components/fields/versioned-document-list-item-fc";
import {
  FormControl,
  FormGroup,
} from "@mui/material";
export const ListContext = createContext();

var MAX_FILE_SIZE = 5242880;

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    formDefField: {
      width: "calc(100% - 16px)"
    },
    noDocument: {
      display: 'flex',
      'align-items': 'center',
      'justify-content': 'center',
      fontWeight: 500,
      color: '#ccc',
      marginLeft: 15,
      marginTop: 7
    },
    dropzone: {
      border: '1px dashed #ccc',
      padding: 15,
      marginLeft: 10,
      marginTop: 0,
      backgroundColor: grey[100],
      flex: 'auto',
      display: 'flex',
      'align-items': 'center',
      'justify-content': 'center',
      cursor: 'pointer',
      minWidth: 240
    },
    dropzoneError: {
        border: '1px dashed #ccc',
        padding: 15,
        marginLeft: 10,
        marginTop: 0,
        backgroundColor: red[100],
        flex: 'auto',
        display: 'flex',
        'align-items': 'center',
        'justify-content': 'center',
        cursor: 'pointer',
        minWidth: 240
    },
    dropZoneWarn: {
        border: "1px dashed #ffe002 !important",
        padding: 15,
        marginLeft: 10,
        marginTop: 0,
        backgroundColor: grey[100],
        flex: 'auto',
        display: 'flex',
        'align-items': 'center',
        'justify-content': 'center',
        cursor: 'pointer',
        minWidth: 240
    },
    dropZoneHistory: {
        border: "1px dashed #1614b3 !important",
        padding: 15,
        marginLeft: 10,
        marginTop: 0,
        backgroundColor: grey[100],
        flex: 'auto',
        display: 'flex',
        'align-items': 'center',
        'justify-content': 'center',
        cursor: 'pointer',
        minWidth: 240
    },
    required: {
      color: "red",
      fontWieght: 600,
      fontSize: "0.85rem"
    },
  })
);

interface VersionedDocumentListFieldProps {
    fieldDefinition: any;
    policyMessages?: any;
    readOnlyOverride?: boolean;
}

export const VersionedDocumentListField: React.FC<VersionedDocumentListFieldProps> = ({
    fieldDefinition,
    policyMessages,
    readOnlyOverride,
  }) => {
    const classes = useStyles();   
   
    const [fieldValue, setFieldValue] = useContext(ValueContext); 
    const [uploading, setUploading] = useState(false);
    const [error, setError] = useState(undefined);

    const onDrop = (acceptedFiles: Array<any>, rejectedFiles: Array<any>) => {

        if (rejectedFiles && rejectedFiles.length > 0) {

            setUploading(false)
            var errorSet = false
            rejectedFiles.forEach((f: any) => {
                if (f.file.size > (fieldDefinition.maxSize || MAX_FILE_SIZE)) {
                    setError(`File size cannot exceed ${( (fieldDefinition.maxSize || MAX_FILE_SIZE) /(1024 * 1024)).toFixed(0)}MB`)
                    errorSet = true
                    return;
                }
            });
            if (!errorSet) {
              setError("Invalid file type")
            }
            return
        }

        if (acceptedFiles && acceptedFiles.length > 0) {

            setError(undefined)  
            setUploading(true)

            let vds = cloneDeep(fieldValue);


            if (!vds) {
                vds = {
                    list: []
                  };
            }

            // OK, we have one or more accepted files
            let parseFlag = '';
                if (fieldDefinition.parse) {
                    parseFlag = 'parse=true';
                }

                var opts = '';
                if (fieldDefinition.versionedDocumentOpts){
                  opts = 'opts=' + JSON.stringify(fieldDefinition.versionedDocumentOpts)
                }
                
                var postURL = `/api/attachment-storage`
                if (parseFlag != "" || opts != "") {
                  postURL += "?" + parseFlag + (parseFlag != "" ? "&" + opts : opts)

                }
            for (let f of acceptedFiles) {
              
                request
                    .post(postURL)
                    .attach(f.name, f)
                    .then((response) => {
                        if (response.ok) {
                            const att = {
                            active: {
                                fileName: f.name,
                                contentType: f.type,
                                size: f.size,
                                pageCount: response.body.pageCount,
                                storageKey: response.body.storageKey,
                                data: response.body.data,
                                uploadedOn: new Date(),
                                uploadedBy: {
                                name: PortalUserContext.userContext.displayName,
                                email: PortalUserContext.userContext.email
                              }
                            },
                            priorVersions: []
                            };

                            if (!vds || vds == '') {
                                vds = {
                                    list: []
                                };
                            }
                            
                            if (!vds.list) {
                                vds.list = [];
                            }

                            vds.list.push(att);

                            setUploading(false)
                            setFieldValue(vds);
                        } else {
                            setError('An error occurred uploading the document')  
                            setUploading(false)
                        }
                    })
                    .catch((err) => {
                        setError('An error occurred uploading the document')  
                        setUploading(false)
                });
            }
        }
    }

    let readOnly: boolean = (fieldDefinition.mode == "Read Only" || fieldDefinition.mode == "Display") ? true : false
    if (readOnlyOverride) {
      readOnly = true
    }

    let attachments = Array<any>();
    if (fieldValue && fieldValue != '') {
        attachments = fieldValue.list
    }

    const [listValue, setListValue] = useState(attachments);

    useEffect(() => {
        if (attachments) {
            var lv = attachments
            setListValue(lv)
        }
    }, [fieldValue])

    useEffect(() => {
        var fv = cloneDeep(fieldValue)
        if (fieldValue && listValue) {
            fv.list = listValue
            setFieldValue(fv)
        }
    }, [listValue])

    let dzClass = classes.dropzone
    let prompt = 'Drop file to upload new document';

    if (fieldDefinition.helpText) {
        prompt = fieldDefinition.helpText
    }

    if (policyMessages && policyMessages.length > 0) {
        
        prompt = policyMessages[0].message;

        if (policyMessages[0].title == "Field required") {
            prompt = "At least one document is required"
        }

        switch (policyMessages[0].severity) {
            case 2:
                dzClass = classes.dropzoneError;
              break;
            case 1:
                dzClass = classes.dropZoneWarn;
              break;
            case 4:
                dzClass = classes.dropZoneHistory;
              break
          }
    }

    if (error) {
        prompt = error
        dzClass = classes.dropzoneError;
    }

    let documentView = (
      <div className={classes.noDocument}>
        {'No document uploaded'}
      </div>
    );

    if (fieldDefinition.mode == "Required") {
      documentView = (
        <div className={classes.noDocument}>
          {'No document uploaded'}<span name="RequiredIcon" className={classes.required}>&nbsp;*</span>
        </div>
      );
    }

    if (attachments && attachments.length > 0) {
        documentView = (
            <div>
              {attachments.map((attachment: any, idx) => {
                return (
                    <ListContext.Provider value={[listValue, setListValue]}>
                        <VersionedDocumentListItem
                            idx={idx}
                            fieldDefinition={fieldDefinition}
                            readOnlyOverride={readOnly}
                        />
                  </ListContext.Provider>
                )
              })}
            </div>
          );
    }

    var dropZone;
    dropZone = (
        <Dropzone
          multiple={false}
          minSize={fieldDefinition.minSize}
          maxSize={fieldDefinition.maxSize || MAX_FILE_SIZE}
          accept={fieldDefinition.accept || fieldDefinition.acceptedDocumentTypes}
          disabled={readOnly}
          onDrop={onDrop}>
            <div>
                {prompt}
            </div>
        </Dropzone>
      );

      if (uploading) {
        dropZone = (
          <div className={classes.loading}>
            <CircularProgress color={'inherit'} size={15} thickness={3} />
          </div>
        );
      }
    
  
    return (
        <FormControl name={fieldDefinition.key} className={classes.formDefField}>
          <FormGroup>
            <div style={{ display: 'inline-block' }}>
                  {!readOnly && <div name="DropZone" className={dzClass}>
                    {dropZone}
                  </div>}
              </div>
          </FormGroup>
          {documentView}
        </FormControl>
      );
  };

  export default VersionedDocumentListField;